import * as React from "react";
import Icon from '../../../icons';
import UserImage from '../../../components/UserImage/index';

// Helper to safely extract names and strip out literal "null" strings
const getValidValue = (value) => {
    return ["null", "", null, undefined].includes(value) ? "-" : value;
};

export default class ChangeLog extends React.Component {
    timeOut = null;

    renderPartyLog = (item) => {
        
        switch (item.action) {
            case 2:
                if (item.isNewValueAdded === true) {
                    return (
                        <>
                            added :- <strong>{item.field}</strong><br/>
                            as:- <strong>{item.newValue}</strong>
                        </>
                    );
                }
                if (item.isValueRemoved === true) {
                    return (
                        <>
                            removed :- <strong>{item.field}</strong><br/>
                            as :- <strong>{item.oldValue}</strong>
                        </>
                    );
                }  
                return (
                    <>
                        changed :- <strong>{item.field}</strong><br/>
                        to :- <strong>{item.newValue}</strong><br/>
                        from :- <b>{item.oldValue}</b>
                    </>
                );

            case 1:
                return <>Created a new party on {item.createdDate} at {item.createdTime}</>;
            
            case 3:
                return <>Deleted the party on {item.createdDate} at {item.createdTime}</>;
            
            case 4:
                return <>Activated the party on {item.createdDate} at {item.createdTime}</>;

            case 5:
                return <>Deactivated the party on {item.createdDate} at {item.createdTime}</>;
                
            default:
                return null;
        }
    }

    onMouseEnter = (e, createdBy) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        if (this.timeOut) clearTimeout(this.timeOut);
        
        this.timeOut = setTimeout(() => {
            this.props.openMiniProfile(targetRect, createdBy);
        }, 500);
    }

    onMouseLeave = () => {
        if (this.timeOut) clearTimeout(this.timeOut);
    }

    componentWillUnmount() {
        if (this.timeOut) clearTimeout(this.timeOut);
    }

    render() {
        const { data } = this.props;
        
        // Return null fallback if data or partyData hasn't loaded yet
        if (!data || !data.partyData) return null;

        const partyName = getValidValue(data.partyData.partyContactName);
        const partyOrgName = getValidValue(data.partyData.partyOrgName);

        return (
            <div className="associatedParties">
                <header className="alignMiddle pdl__1 pdr__1">
                    <a href="javascript:void(0)" className="backArrow mr" onClick={this.props.onBackClick}>
                        <Icon name="chev" className="icon shift__top__1 arrow" />
                    </a>
                    <span className="flexGrow alignBase flexWrap">
                        <h2>Party Change Logs</h2>
                    </span>
                    <a className="h__16 ml__1" href="javascript:void(0)" onClick={this.props.onClose}>
                        <Icon name="close" className="icon" />
                    </a>
                </header>
                
                <div className="partiesHistory scrollArea partyScroll pdl__1 pdr__1 animated faster fadeInRight">
                    <label>{partyName}</label>
                    <h3><strong>{partyOrgName}</strong></h3>
                    <p className="mt">
                        created by {data.partyData.partyCreatedBy}
                        {data.partyData.isUserActive !== "True" && <span className="grey"> (InActive)</span>} 
                        on {data.partyData.partyCreationDate} at {data.partyData.partyCreationTime}
                    </p>

                    <ul className="colFlex">
                        {data?.aplog?.map((itemArray, outerKey) => {
                            return itemArray.map((actions, innerIndex) => {
                                // Create a robust compound key combining outer loop index and inner loop index
                                const compoundKey = `${outerKey}-${innerIndex}-${actions.createdBy || ''}`;
                                
                                return (
                                    <li className="userGroup alignMiddle rowFlex" key={compoundKey}>
                                        <div className="userPic selfStart mt">
                                            <UserImage profileUrl={actions.userImage} profileName={actions.userName} /> 
                                        </div>
                                        <div className="userInfo">
                                            <label>
                                                <a 
                                                    onMouseEnter={(e) => this.onMouseEnter(e, actions.createdBy)} 
                                                    onMouseLeave={this.onMouseLeave} 
                                                    href="javascript:void(0)"
                                                >
                                                    {actions.userName}
                                                    {!actions.isUserActive && <span className="grey"> (Inactive)</span>}
                                                </a>
                                            </label>
                                            <p>{actions.orgName}</p>
                                            <label>{actions.createdDate} at {actions.createdTime}</label>
                                            <label>{this.renderPartyLog(actions)}</label>
                                        </div>
                                    </li>
                                );
                            });
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}